import { useState } from "react";
import GlobalModalComponent from "../../../shared/globalModal/GlobalModalComponent";
import styles from "./MessageModal.module.scss";
import successIcon from "../../../../assets/images/pages/login/Success Icon.svg";
import errorIcon from "../../../../assets/images/pages/login/Error Icon.svg";
import CloseIcon from "../../../../assets/images/pages/login/CloseButton.svg";
import { data, Link, useNavigate } from "react-router-dom";
import {
  setIsLogin,
  setIsMessage,
  setIsOtp,
  setIsRegister,
  setOperationType,
} from "../../../../redux/Slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import MainButton from "../../../shared/button/MainButton";
import { RootState } from "../../../../redux/store";

const MessageModal = () => {
  const [isModal, setIsModal] = useState(false);
  const messageType = useSelector(
  (state: RootState) => state.user.messageType
);
  const { data } = useSelector((state: RootState) => state.translationData);

  const messageStatus = useSelector(
    (state: RootState) => state.user.isMessageStatus
  );
  const errorMesssage = useSelector(
    (state: RootState) => state.user.errorMessage
  );
  const navigate = useNavigate();
  const dispach = useDispatch();

  const LoginClose = () => {
    dispach(setIsRegister(false));
    dispach(setIsOtp(false));
    dispach(setIsLogin(false));
    dispach(setIsMessage(false));
  };
  const handleBackBtn = () => {
    if (messageStatus) {
      navigate("/auth");
      dispach(setIsLogin(true));
      dispach(setIsMessage(false));
      dispach(setIsOtp(false));
      dispach(setIsRegister(false));
    } else {
      dispach(setIsOtp(true));
      dispach(setIsMessage(false));
    }
  };
  return (
    <GlobalModalComponent isOpen={true} onClose={() => setIsModal(!isModal)}>
      <div className={styles.messageModal}>
        <div className={styles.headerLogin}>
          <Link to={"/"} onClick={LoginClose} className={styles.closeButton}>
            <img
              className={styles.closeIcon}
              src={CloseIcon}
              alt="EyeIcon"
              onClick={LoginClose}
            />
          </Link>
        </div>

        <div className={styles.modalContainer}>
          <div className={styles.successImg}>
            <img src={messageStatus ? successIcon : errorIcon} alt="status" />
          </div>
          {/* <h3 className={styles.title}>
            {messageStatus
              ? "Qeydiyyatınız uğurla tamamlandı."
              : "Yenidən yoxlayın."}
          </h3>
          <p className={styles.subtitle}>
            {errorMesssage
              ? errorMesssage
              : messageStatus
              ? "Colibri Express-i seçdiyiniz üçün təşəkkür edirik."
              : "Bütün məlumatlarınızı zəhmət olmasa diqqətlə doldurun."}
          </p> */}
          <h3 className={styles.title}>
            {messageStatus
              ? messageType === "register"
                ? "Qeydiyyatınız uğurla tamamlandı."
                : "Şifrəniz uğurla dəyişdirildi."
              : data?.auth_common_try_again}
          </h3>

          <p className={styles.subtitle}>
            {errorMesssage
              ? errorMesssage
              : messageStatus
              ? messageType === "register"
                ? data?.auth_common_thank_you
                : "Yeni şifrənizlə daxil ola bilərsiniz."
              : data?.auth_common_fill_all_fields}
          </p>
          <div>
            <MainButton
              onClick={handleBackBtn}
              className={styles.back_btn}
              text={`${messageStatus ? "Daxil ol" : "Geri dön"}`}
            />
          </div>
        </div>
      </div>
    </GlobalModalComponent>
  );
};

export default MessageModal;
